export default {
  dream: {
    title: "愿景和使命",
    titledetail:
      '公司愿景："生产一种产品，推动一种进步；释放一种能量，改变一次世界"',
    content: `在上海超导科技股份有限公司一楼洁净车间入口，展示着公司的愿景；而愿景的前半句已放大为醒目的标语，一进厂区就能看到。
---总裁朱佳敏博士深入解读了"公司愿景"："在电力领域，凭借高温超导无电阻的特性，已有超导电缆、限流器等民用实用型装备投入运营，公司愿景的前半句已经开始落地；同时，在高温超导材料的加持下，紧凑型核聚变的研发也取得了较为显著的进展，众多发达国家和地区的科研机构和商业公司正在逐步推动实现改变世界的愿景。我们期盼早日实现这一愿景，让公司愿景的后半句也成为厂区内的大标语。"年仅37岁的朱佳敏博士是公司的1号员工，完整经历了上海超导从实验室逐步走向工业化的全过程，在上海超导公司，有数十位年轻且拥有十多年从业经验的高素质人才。年轻的团队、扎实的技术、领先的产品力，是公司在全球高温超导行业立足的基础。
---2010年，上海市将"高温超导"定位为战略新兴产业，这一战略决策开启了上海市在全球高温超导领域产业的领先性征程，不仅在电力领域上具备完整的产业链，在核聚变这样的未来战略产业也涌现出领先的商业公司。2024年11月15日，上海市经信委、发改委、教委、科委发布了《上海市促进新材料产业高质量发展实施方案（2025-2027年）》，高温超导重要领域应用的政策推动力再度加磅，整个产业已经从0-1开始了1-10、10-100的加速阶段。
---成立于2011年的上海超导，国内市场占有率80%以上，是多项"全球首个"超导应用项目的核心供应商及独家供货商。目前，公司年产量与销量均已超过千公里，下游涵盖可控核聚变、超导电力、高场磁体等多个尖端应用领域。
---在前13年的发展历程中，上海超导获得了上海市委市政府的大力支持，成功孵化和投资了100多家科创板企业的上海市国有核心投资平台——上海科技创业投资公司是公司的重要股东，自2022年开始，更多的产业投资者成为上海超导的新股东，包括精达股份、申能集团等，进一步完善了公司的治理结构。
---上海超导深度参与的多项"全球首个"项目包括美国CFS公司大口径20T强磁场磁体、国内首条10千伏三相同轴高温交流超导电缆、国内首条35千伏公里级高温超导电缆、国际首台MW级超导感应加热装置、电动磁悬浮列车、32.35T全超导磁体、26.8T全REBCO高温超导磁体、能量奇点洪荒-70等，获得了国内外客户的高度认可。这些应用/示范项目的成功落地，发挥了示范引领作用，同时也为上海超导进一步拓宽国内外市场打下基础。
---上海超导的第一轮扩产始于2022底年、已于2024年第3季度成功运行，目前产能已位居全球前列；在第一轮扩产成功的基础上，公司已开启第二轮扩产。现阶段，公司产品供不应求，特别是在全球基于高温超导磁体的紧凑型核聚变研发加速的背景下，稳定批量提供高端产品、承担各战略研发项目的材料支撑已成为公司24小时连续生产的任务目标。
---继往开来，行业的第一小步已经跨出，在下游应用领域专业团队的艰苦努力下，用高温超导材料"改变一次世界"的愿景或许即将实现。
`,
    other: {},
  },
  events: {
    title: "公司大事记",
    breadcrumb: "关于公司 > 公司大事记",
    timeline: [
      {
        year: "2025",
        items: [
          "入选2025年上海市重大建设项目计划",
          "二期扩产项目顺利推进中，建成后产能将达4,000km/年；三期扩产项目已完成备案，建成后上海超导总产能将达20,000km/年",
          "荣获“上海市创新型企业总部”称号",
          "入选上海市经信委2024年先进材料领域十件大事年度盘点",
        ],
      },
      {
        year: "2024",
        items: [
          "2024年底一期扩产项目顺利完成，产能达2,000km/年",
          "中科院等离子体所及其联合研发团队成功研制26.8T全REBCO高温超导励磁成功，打破了全高温超导磁体26.4T最高记录，上海超导为该项目供应所需的全部超导材料",
          '上海超导为联创超导批量供应超导带材、于2024年完成供货，用于高温超导磁控硅单晶生长装置，该技术于2025年通过专业鉴定',
          '成功通过工信部第三批专精特新“小巨人”企业复核；荣获上海市2024年度“科技创新行动计划”科技小巨人称号、上海市企业技术中心认定；上海市高温超导材料与应用技术重点实验室通过评估、获评“良好”',
          "荣获2023年度中国电工技术学会科技进步一等奖，电力科学技术奖一等奖，北京市、四川省科学技术二等奖",
          "上海超导作为全国耐心资本被投典型案例入选“2024央视财经金融强国年度盛典”本年度全国案例"
        ],
      },
      {
        year: "2023",
        items: [
          "完成整体搬迁，康桥一期厂房投入使用；开启全面扩产计划，全方位提升产能和带材交付能力",
          "再次获得能量奇点大型采购订单、并于2024年完成供货，用于大孔径强磁场经天磁体，该磁体于2025年完成首轮通流实验，磁场强度达到21.7T",
          '中标南方电网高性能YBCO高温超导材料采购项目，用于10MJ高温超导储能系统，该项目属国家重点研发计划',
          '成为上海市未来产业先进核能专家委员会委员单位',
        ],
      },
      {
        year: "2022",
        items: [
          "完成股权重组，形成以上市公司、管理团队、国有资本及主流投资机构为股东主体的新的股权结构",
          "获得能量奇点大型采购订单、并于2023年完成供货，用于全超导托卡马克装置洪荒70",
          '获得中科院等离子体所采购订单、并于2022年完成供货，用于24.1T全REBCO高温超导磁体，该磁体是国内首个20T以上全REBCO密绕型超导磁体、使用的超导带材均由上海超导提供',
          '由上海超导作为牵头单位承担的《面向强磁体技术的高电流密度高温超导导体技术》等三个科技研发项目成功通过上海市科学技术委员会组织的专家组联合验收',
          '上海市高温超导材料与应用技术重点实验室通过验收',
        ],
      },
      {
        year: "2021",
        items: [
          "中标法国Lorraine大学电动飞机超导线圈的采购项目，是上海超导在国际上首次中标的项目",
          '公司"高温超导带材制备关键技术和产业化"项目通过科技成果鉴定',
          '荣获上海市"专精特新"中小企业称号、工信部重点专精特新"小巨人"企业称号',
        ],
      },
      {
        year: "2020",
        items: [
          "获得英国剑桥大学超导磁体订单，是上海超导在国际市场获得的首个磁体订单",
          '开始向联创超导批量供应超导带材，用于国际上首台兆瓦级高温超导感应加装置，该装置于2023年成功投运',
          "中标上海交通大学第二代高温超导带材采购项目、并于2021年完成供货，用于国内首套高温超导电动悬浮全要素试验系统",
          '获得中天集团大型采购订单、并于2021年完成供货，用于南方电网10千伏三相同轴高温交流超导电缆示范工程，该项目于2021年成功投运',
          '荣获上海市科委“上海市高温超导材料与应用技术重点实验室”授牌',
          "成立浦东新区企业博士后科研工作站-上海超导科技股份有限公司分站",
        ],
      },
      {
        year: "2019",
        items: [
          "获得上海电缆所大型采购订单、并于2020年完成供货，用于国内首个35千伏公里级高温超导电缆示范工程项目，该项目于2021年成功在沪投运",
          '中标广东电网"160kV超导直流电阻型限流器的研制"项目，是上海超导在国内的首个千万级别订单，同年完成批量的双面封装不锈钢第二代高温超导带材的供货',
          "分别与英国Tokamak Energy、美国CFS公司签订大型采购订单，先后于2019年、2020年完成供货，均用于可控核聚变强场磁体的研制，英国Tokamak Energy于2023年2月完成DEMO4磁体绕制，美国CFS公司于2021年9月成功绕制20T强磁场磁体、并通过测试",
          "向中科院电工所团队提供高温超导带材，用于32.35T全超导磁体的端部线饼，该磁体打破了32.0T超导磁体的世界纪录",
          "国产基带完成第一个长带镀膜实验，基带国产化研究进程加快",
          "上海超导关键性材料及应用产业化基地项目获得成果鉴定",
        ],
      },
      {
        year: "2018",
        items: [
          '举办"2018上海高温超导会议"(ShanghaiHigh-Temperature Superconductor Conference 2018, ShHTS 2018)',
          "成为全国超导标准化技术委员会成员单位",
        ],
      },
      {
        year: "2017",
        items: [
          '中标北京交通大学220kV交流电阻型超导限流器研制项目，并于同年完成供货，该项目为"国家863计划"，于2018年1月通过验收',
          "再获英国Tokamak Energy订单，正式开始向国际核聚变应用批量供货",
        ],
      },
      {
        year: "2016",
        items: [
          "先后获得德国KIT、瑞士PSI、英国Tokamak Energy等单位的采购合同，应用方向涵盖大电流导体、超导磁体、测试等领域，开始探索国际市场",
          "作为国内唯一一家参展的二代高温超导带材供应商，出席超导界规模最大、规格最高的ASC(Applied Superconductivity Conference)大会",
          '技术成果作为上海市的亮点项目入选并亮相国家"十二五"科技创新成就展',
        ],
      },
      {
        year: "2015",
        items: [
          "中标中国科学院电工研究所超导磁体用YBCO超导带材采购项目，是上海超导在国内的首个中标项目，拉开了上海超导正式对外销售的序幕",
          "公司张江高科技园区研发中心投入使用",
          '荣获"高新技术企业"称号',
        ],
      },
      {
        year: "2014",
        items: [
          "自主研发世界一流的低阻/无阻接头技术，使高温超导带材的产业化进程得以进一步加速",
        ],
      },
      {
        year: "2013",
        items: [
          "攻克二代高温超导带材大规模产业化中的生产设备与工艺，自主建成国内首条公里级二代高温超导带材生产线",
        ],
      },
      {
        year: "2012",
        items: ["完成基于自主基带的超导带材制备工艺，并布局自主装备"],
      },
      {
        year: "2011",
        items: ["上海超导科技股份有限公司成立"],
      },
      {
        year: "2010",
        items: [
          "成功研制国内首条百米级第二代高温超导带材，具有300A的载流能力和极高的性价比，奠定带材产业化的基础",
        ],
      },
    ],
  },
  introduction: {
    title: "公司介绍",
    content: `上海超导科技股份有限公司（简称"上海超导"）是一家专注于高温超导材料的研发、生产和销售的高新技术企业。公司核心业务涵盖高温超导带材及相关技术服务，产品广泛应用于可控核聚变、超导电力、高场磁体等前沿科技领域。上海超导致力于成为全球超导领域的领跑者，凭借卓越的产品性能、高性价比及全方位的技术服务，历经多年深耕与发展，目前已成长为全球第二代高温超导材料的核心供应商之一、年产量及销量均超过千公里。
---经国内权威机构鉴定，公司"第二代高温超导带材整体达到国际同类产品的先进水平，其中低温强场特性、超导低阻接头、光纤内嵌超导带材及监测技术达到了国际领先水平"；多家国际权威机构评估，公司带材产品性能指标均居全球前20%，性价比超过国内外同类产品。
---上海超导紧密围绕国家战略，瞄准超导应用领域市场需求，始终坚持产品研发与技术创新。公司先后承担了"国家重点研发计划"、"上海市科委重大专项"等多项国家和上海市科技攻关项目，并荣获上海市战略新兴产业专项支持，形成了科研-量产-品控-技术服务一体化的全流程业务体系。公司系国家级专精特新"小巨人"企业、上海市科技"小巨人"企业、上海市"专精特新"中小企业、"上海市认定企业技术中心"、"上海市专利工作试点企业"、"浦东新区企业博士后科研工作站"，建有"上海市高温超导材料与应用技术重点实验室"、"上海超导材料及系统工程技术研究中心"；同时致力于新技术的突破与创新，目前已获得90余项自主知识产权授权，牵头或参与起草8项国家、行业或团体标准，已荣获中国有色金属工业科学技术奖一等奖、中国电工技术学会科技进步奖一等奖、中国电力科学技术奖一等奖等荣誉。
---凭借卓越的产品性能与优质的服务，上海超导已拥有稳定多元化的优质客户群，为全球180多家单位提供产品与服务。目前公司已与南方电网、国家电网、中科院等离子体所、中科院电工所、美国MIT、德国KIT、美国CFS公司、英国TE公司、新西兰RRI研究所、能量奇点、联创超导等国内外企业及科研机构建立了紧密的合作关系。未来，上海超导将继续秉持科技创新的核心理念，深耕国内市场、积极开拓国外市场，深化国际合作、拓宽应用领域，进一步推动超导技术的商业化进程，为构建超导科技新纪元贡献力量。
`,
  },
  partners: {
    title: "合作伙伴",
    subtitle: "强强联手，共同推动高温超导行业发展",
    content: [
      {
        url: "/images/partners/中国科学院合肥物质科学研究院.jpg",
        alt: "中国科学院合肥物质科学研究院",
        altdetail: "中国科学院合肥物质科学研究院",
        desc: "领域：超导磁体、超导技术",
      },
      {
        url: "/images/partners/中国科学院电工研究所.jpg",
        alt: "中国科学院电工研究所",
        altdetail: "中国科学院电工研究所",
        desc: "领域：超导磁体、超导技术",
      },
      {
        url: "/images/partners/南方电网.jpg",
        alt: "南方电网",
        altdetail: "南方电网",
        desc: "领域：超导同步调相机，超导变压器",
      },
      {
        url: "/images/partners/能量奇点.jpg",
        alt: "能量奇点",
        altdetail: "能量奇点",
        desc: "领域：可控核聚变装置",
      },
      {
        url: "/images/partners/MIT.jpg",
        alt: "MIT",
        altdetail: "MIT",
        desc: "领域：可控核聚变磁体",
      },
      {
        url: "/images/partners/KIT.jpg",
        alt: "KIT",
        altdetail: "KIT",
        desc: "领域：超导磁体、CORC",
      },
      {
        url: "/images/partners/CFS.jpg",
        alt: "CFS",
        altdetail: "CFS",
        desc: "领域：可控核聚变",
      },
      {
        url: "/images/partners/Tokamak Energy.jpg",
        alt: "Tokamak Energy",
        altdetail: "Tokamak Energy",
        desc: "领域：可控核聚变",
      },
      {
        url: "/images/partners/江西联创光电超导应用有限公司.jpg",
        alt: "江西联创光电超导应用有限公司",
        altdetail: "江西联创光电超导应用有限公司",
        desc: "领域：超导感应加热",
      },
      {
        url: "/images/partners/上海电缆研究所有限公司.jpg",
        alt: "上海电缆研究所有限公司",
        altdetail: "上海电缆研究所有限公司",
        desc: "领域：超导电缆",
      },
      {
        url: "/images/partners/National MagLab.jpg",
        alt: "National MagLab",
        altdetail: "National MagLab",
        desc: "领域：高场磁体、聚变磁体",
      },
      {
        url: "/images/partners/CERN.jpg",
        alt: "CERN",
        altdetail: "CERN",
        desc: "领域：电流引线，超导磁体",
      },
      {
        url: "/images/partners/PPPL.jpg",
        alt: "PPPL",
        altdetail: "PPPL",
        desc: "领域：可控核聚变",
      },
      {
        url: "/images/partners/RRI.jpg",
        alt: "RRI",
        altdetail: "RRI",
        desc: "领域：超导磁体",
      },
      {
        url: "/images/partners/CEA.jpg",
        alt: "CEA",
        altdetail: "CEA",
        desc: "领域：超导磁体,CORC",
      },
      {
        url: "/images/partners/中车长春轨道客车股份有限公司.jpg",
        alt: "中车长春轨道客车股份有限公司",
        altdetail: "中车长春轨道客车股份有限公司",
        desc: "领域: 超导磁悬浮",
      },
      {
        url: "/images/partners/University of Cambridge.jpg",
        alt: "University of Cambridge",
        altdetail: "University of Cambridge",
        desc: "领域: MRI，超导磁体",
      },
      {
        url: "/images/partners/中国电力科学研究院有限公司.jpg",
        alt: "中国电力科学研究院有限公司",
        altdetail: "中国电力科学研究院有限公司",
        desc: "领域: 超导限流器",
      },
      {
        url: "/images/partners/中天集团上海超导技术有限公司.jpg",
        alt: "中天集团上海超导技术有限公司",
        altdetail: "中天集团上海超导技术有限公司",
        desc: "领域: 超导电缆",
      },
      {
        url: "/images/partners/清华大学.jpg",
        alt: "清华大学",
        altdetail: "清华大学",
        desc: "领域: 超导磁体",
      },
      {
        url: "/images/partners/中国科学院高能物理研究所.jpg",
        alt: "中国科学院高能物理研究所",
        altdetail: "中国科学院高能物理研究所",
        desc: "领域: 低温导体",
      },
      {
        url: "/images/partners/上海交通大学.jpg",
        alt: "上海交通大学",
        altdetail: "上海交通大学",
        desc: "领域: 超导磁悬浮、CORC",
      },
      {
        url: "/images/partners/中国科学院近代物理研究所.jpg",
        alt: "中国科学院近代物理研究所",
        altdetail: "中国科学院近代物理研究所",
        desc: "领域: 超导磁体",
      },
      {
        url: "/images/partners/陕西星环聚能科技有限公司.jpg",
        alt: "陕西星环聚能科技有限公司",
        altdetail: "陕西星环聚能科技有限公司",
        desc: "领域: 可控核聚变",
      },
      {
        url: "/images/partners/北京交通大学.jpg",
        alt: "北京交通大学",
        altdetail: "北京交通大学",
        desc: "领域: 超导电缆、超导限流器",
      },
      {
        url: "/images/partners/CNRS.jpg",
        alt: "CNRS",
        altdetail: "CNRS",
        desc: "领域: 超导磁体",
      },
      {
        url: "/images/partners/PSI.jpg",
        alt: "PSI",
        altdetail: "PSI",
        desc: "领域: 可控核聚变",
      },
      {
        url: "/images/partners/ACT.jpg",
        alt: "ACT",
        altdetail: "ACT",
        desc: "领域: CORC",
      },
      {
        url: "/images/partners/ENEA.jpg",
        alt: "ENEA",
        altdetail: "ENEA",
        desc: "领域: 超导磁体",
      },
      {
        url: "/images/partners/西南交通大学.jpg",
        alt: "西南交通大学",
        altdetail: "西南交通大学",
        desc: "领域: 超导磁体",
      },
      {
        url: "/images/partners/华中科技大学.jpg",
        alt: "华中科技大学",
        altdetail: "华中科技大学",
        desc: "领域: 超导磁体",
      },
      {
        url: "/images/partners/Airbus.jpg",
        alt: "Airbus",
        altdetail: "Airbus",
        desc: "领域: 超导电动飞机",
      },
      {
        url: "/images/partners/VEIR.jpg",
        alt: "VEIR",
        altdetail: "VEIR",
        desc: "领域: 超导电缆",
      },
      {
        url: "/images/partners/Supergrid.jpg",
        alt: "Supergrid",
        altdetail: "Supergrid",
        desc: "领域: 超导限流器",
      },
      {
        url: "/images/partners/上海翌曦科技发展有限公司.jpg",
        alt: "上海翌曦科技发展有限公司",
        altdetail: "上海翌曦科技发展有限公司",
        desc: "领域: 超导磁体",
      },
      {
        url: "/images/partners/Renaissance Fusion.jpg",
        alt: "Renaissance Fusion",
        altdetail: "Renaissance Fusion",
        desc: "领域: 可控核聚变",
      },
      {
        url: "/images/partners/University of Lorraine.jpg",
        alt: "University of Lorraine",
        altdetail: "University of Lorraine",
        desc: "领域: 超导电动飞机",
      },
    ],
  },
  honors: {
    title: "荣誉资质",
    subtitle: "多项国家级、省部级荣誉资质",
    content:
      '上海超导已获得多项国家、省部级荣誉资质。2014年上海市科委授权成立"上海超导材料及系统工程技术研究中心"（洪智勇任研究中心主任），2018年获评上海市专利工作试点企业，2020年授权成立"上海市高温超导材料与应用技术重点实验室"（朱佳敏任重点实验室主任），2021年获评国家级专精特新"小巨人"企业、上海市"专精特新"中小企业、上海市科技小巨人培育企业等称号。',
    list: [
      {
        title: '工信部专精特新"小巨人"企业',
        image:
          "/images/honors/工信部专精特新小巨人企业（2024-9-2通过复核）.jpg",
      },
      {
        title: "国家知识产权优势企业",
        image: "/images/honors/国家知识产权优势企业.jpg",
      },
      {
        title: "高新技术企业",
        image: "/images/honors/高新技术企业.png",
      },
      {
        title: '上海市"专精特新"中小企业',
        image: "/images/honors/上海市专精特新中小企业（2023-4-19通过复核）.png",
      },
      {
        title: "上海市创新型企业总部",
        image: "/images/honors/上海市创新型企业总部.jpg",
      },
      {
        title: '上海市"科技小巨人（培育）"企业 (上海市科技“小巨人”企业已立项)',
        image: "/images/honors/上海市科技小巨人（培育）企业.jpg",
      },
      {
        title: "上海超导材料及系统工程技术研究中心",
        image: "/images/honors/上海超导材料及系统工程技术研究中心.jpg",
      },
      {
        title: "上海市高温超导材料与应用技术重点实验室",
        image: "/images/honors/上海市高温超导材料与应用技术重点实验室.jpg",
      },
      {
        title: "上海市企业技术中心",
        image: "/images/honors/上海市企业技术中心.jpg",
      },
      {
        title: "加强型二代高温超导带材 A级",
        image: "/images/honors/加强型二代高温超导带材 A级.png",
      },
      {
        title: "第二代高温超导带材 A级",
        image: "/images/honors/第二代高温超导带材 A级.jpg",
      },
      {
        title: "低阻内封接头第二代高温超导带材 B级",
        image: "/images/honors/低阻内封接头第二代高温超导带材 B级.jpg",
      },
      {
        title: "中国电工技术学会科学技术奖-一等奖",
        image: "/images/honors/中国电工技术学会科学技术奖-一等奖.jpg",
      },
      {
        title: "中国专利优秀奖",
        image: "/images/honors/中国专利优秀奖.jpg",
      },
      {
        title: "中国有色金属工业科学技术奖-一等奖",
        image: "/images/honors/中国有色金属工业科学技术奖-一等奖.jpg",
      },
      {
        title: "发明创业奖成果奖-一等奖",
        image: "/images/honors/发明创业奖成果奖-一等奖.jpg",
      },
      {
        title: "发明创业奖创新奖-一等奖",
        image: "/images/honors/发明创业奖创新奖-一等奖.jpg",
      },
      {
        title: "电力科学技术进步奖一等奖",
        image: "/images/honors/电力科学技术进步奖一等奖.jpg",
      },
      {
        title: "第三十五届上海市优秀发明-金奖",
        image: "/images/honors/第三十五届上海市优秀发明-金奖.jpg",
      },
      {
        title: "北京市科学技术奖-二等奖",
        image: "/images/honors/北京市科学技术奖-二等奖.png",
      },
      {
        title: "四川省自然科学奖-二等奖",
        image: "/images/honors/四川省自然科学奖-二等奖.png",
      },
      {
        title: "中国有色金属工业科学技术奖-二等奖",
        image: "/images/honors/中国有色金属工业科学技术奖-二等奖.png",
      },
      {
        title: "科技部荣誉证书（十二五成就展）",
        image: "/images/honors/科技部荣誉证书（十二五成就展）.png",
      },
      {
        title: '"创·在上海"国际创新创业大赛总决赛(成长组)二等奖',
        image: "/images/honors/国际创新创业大赛总决赛(成长组)二等奖.png",
      },
    
      {
        title: "第18届工博会工业设计金奖",
        image: "/images/honors/第18届工博会工业设计金奖.jpg",
      },
    ],
  },
  structure: {
    title: "下设机构",
    list: [
      {
        title: "上海超导材料及系统工程技术研究中心",
        image: "/images/structure/上海超导材料及系统工程技术研究中心.jpg",
        url: "center",
      },
      {
        title: "上海市高温超导材料与应用技术重点实验室",
        image: "/images/structure/上海市高温超导材料与应用技术重点实验室.jpg",
        url: "lab",
      },
      {
        title: "合肥核聚磁体科技有限公司",
        image: "/images/structure/核聚磁体.jpg",
        url: "tech",
      },
      {
        title: "合肥上超材料科技有限公司",
        image: "/images/structure/上超材料.jpg",
        url: "materials",
      },
    ],
    center: {
      title: "上海超导材料及系统工程技术研究中心",
      content: `上海超导材料及系统工程技术研究中心（以下简称"工程中心"）于2012年由上海市科学技术委员会批准设立，由上海超导科技股份有限公司负责组建。工程中心以上海市科技发展需求为牵引，致力于国产高温超导材料的产业化及其大规模工业应用。
---洪智勇博士任工程中心主任，目前工程中心有中高级职称31名，其中博士硕士研究生17名；骨干队伍中，有青年拔尖人才1人，优秀学术/技术带头人1人，浦江人才2名，青年启明星3人。工程中心聘请国内超导技术及应用领域的顶尖专家和学者组成技术委员会，为工程中心的技术进步和发展升级提供强有力的支持。

---工程中心的研究方向包括：第二代高温超导材料、超导带材生产装备、超导电力应用、超导节能应用、超导磁体技术等。

---在工程中心的推动下，上海超导已初步实现国产高温超导带材的产业化，带材的产能、性能、性价比、市场占有率均处于国内龙头、国际一流的地位。

---依托上海超导，工程中心以保障下游应用对高性能超导材料的技术及产量需求为核心任务，与下游应用企业紧密合作，精准开展技术攻关，确保匹配各类应用需求；对接国内零部件供应企业，引进核心部件国产化技术，实现快速扩产和工业化生产。

---工程中心与上海超导围绕国产高温超导材料的产业化及大规模工业应用，充分整合资源，不断提升自主研发能力和工程应用能力，为超导技术的创新发展及工业应用提供有力支撑。`,
      other: {
        picture: {
          url: "/images/structure/上海超导材料及系统工程技术研究中心.jpg",
          alt: "上海超导材料及系统工程技术研究中心",
        },
      },
    },
    lab: {
      title: "上海市高温超导材料与应用技术重点实验室",
      content: `上海市高温超导材料与应用技术重点实验室（以下简称"重点实验室"）于2019年由上海市科学技术委员会批准设立，由上海超导科技股份有限公司负责组建。重点实验室围绕国家前沿材料发展战略需求、上海市科技重大专项以及科技创新基地建设规划，致力于突破我国高温超导产业及实际应用中的关键技术瓶颈。
      ---朱佳敏博士任重点实验室主任，目前重点实验室有中高级职称37名，其中博士硕士研究生16名，青年启明星1人。重点实验室聘请国内超导领域著名专家学者组成学术委员会，为重点实验室项目的科学性和创新性提供前瞻性指导。
      ---重点实验室的研究方向包括：高温超导材料技术、高温超导强电磁应用技术、高温超导共性前瞻技术等。
      ---依托上海超导的产业化优势和上海交通大学的科研底蕴，重点实验室以高温超导材料为核心，从应用基础研究出发，构建全面的高温超导应用技术创新体系，解决和突破高温超导发展在材料制备和工程应用方面所面临的科学和工程技术难题，推动智能制造在高温超导中的应用，探索企业-高校联合建设重点试验室的产学研用新模式。目前，重点实验室已为多个国家重大科学、民生项目提供了关键技术和材料支持。
      ---重点实验室与上海超导通过"产学研用"模式，集聚创新资源，聚焦创新重点，积极推动高温超导材料向高性能、低成本方向发展，促进产业上下游协同发展，为高温超导技术材料与应用产业发展贡献新的动力。`,
      other: {
        picture2: {
          url: "/images/structure/上海市高温超导材料与应用技术重点实验室——学术委员会.jpg",
          alt: "上海超导材料及系统工程技术研究中心",
        },
        picture1: {
          url: "/images/structure/上海市高温超导材料与应用技术重点实验室.jpg",
          alt: "上海超导材料及系统工程技术研究中心",
        },
      },
    },
    tech: {
      title: "合肥核聚磁体科技有限公司",
      content:
        "合肥核聚磁体技术有限公司由上海超导和中国科学院等离子所合作成立，专注于以可控核聚变为主要应用方向的高温超导磁体技术，公司设立于合肥，将逐步构建制造高温超导磁体的专业人才队伍和设备，既满足为国家大科学工程服务的目标，又致力于高温超导磁体的研发、应用和产品推广。",
    },
    materials: {
      title: "合肥上超材料科技有限公司",
      content:
        "合肥上超材料科技有限公司是在中国科学院等离子体所以国家大科学工程的需求进行产业集聚、牵引超导领域向下游企业在合肥设立子公司的大背景下，于2023年由上海超导投资设立的控股子公司。公司在合肥建设高温超导材料生产线，面向可控核聚变领域所需的优越的低温强磁场性能带材需求，批量化供应高性能高温超导带材，支撑我国大科学工程建设。",
    },
  },
};
